import { Injectable } from '@angular/core';
import { HttpFunctionsService } from '../http-services/http-functions.service';
import { Socket } from 'socket.io';
import { BehaviorSubject, Observable, catchError, map, throwError } from 'rxjs';
import { NegotiationList, TAB_OPTIONS } from 'src/app/models/negotiation';
import { AuthService } from '../Auth/auth.service';
import { UserDetails } from 'src/app/models/user-details.model';
import { ProfileImgWithNameLetterPipe } from 'src/app/pipes/profile-img-name-letter/profile-img-with-name-letter.pipe';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationResModel } from 'src/app/models/notification.model';
export interface NegotiationResponseList {
  buying: Array<NegotiationList>,
  selling: Array<NegotiationList>
}

export interface NotificationChangeEvent {
  notificationType: string;
  notificationData: NotificationResModel[];
  unreadCount: number;
  total: number;
  notificationId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class NegotiationService {
  negotiationUrl: string = 'negotiations';
  notification: string = "notifications"
  labelArray: Array<any> = [
    {
      name: "License Fee",
      type: "price"
    },
    {
      name: "Publishing Rights",
      type: "percentage"
    },
    {
      name: "Master Rights",
      type: "percentage"
    }
   ];
//    {
//     name: "Credits",
//     type: "boolean"
// }
  currentUserData: UserDetails;
  notificationChanges: BehaviorSubject<NotificationChangeEvent[]> = new BehaviorSubject<NotificationChangeEvent[]>([{
    notificationType: 'initial',
    notificationData: [],
    unreadCount: 0,
    total: 0
  }]);
  private notificationsCache: NotificationResModel[] = [];
  private unreadCountCache: number = 0;
  private totalCountCache: number = 0;
  constructor(
  private httpService: HttpFunctionsService,
  private authService: AuthService,
  private profileStringWithNameLetterPipe: ProfileImgWithNameLetterPipe,
  private router: Router,
  private routerActivated: ActivatedRoute ) { 
      this.authService.currentUserDetails.subscribe((userData: UserDetails) => {
        if (userData &&  Object.keys(userData).length > 0) {
          this.currentUserData = userData;
        }
      });
    }

  /**
   * Get all negotiation api function
   * @returns @object NegotiationResponseList
   */
  getAllNegotiations(isShowLoader: boolean = true): Observable<NegotiationResponseList> {
    return this.httpService.getMethod(this.negotiationUrl, isShowLoader)
  }

  /**
   * Get details particular negotiation api
   * function
   * @param negotiationId @string
   * @returns 
   */
  getParticularNegotiationsDetails(negotiationId: any, isShowLoader: any =  true) {
    return this.httpService.getMethod(this.negotiationUrl+`/${negotiationId}`, isShowLoader);
  }

  /**
   * Close Negotiation api function
   * @param negotiationId 
   * @returns 
   */
  closeNegotiation(negotiationId: any){
    return this.httpService.deleteMethod(this.negotiationUrl+`/${negotiationId}`);
  }

  /**
   * Create negotiation api function
   * on first time  
   * @param body @object
   * @returns 
   */
  createNegotiation(body: any) {
    return this.httpService.postMethod(this.negotiationUrl+`/create`,body);
  }

  /**
   *  counter offer api Function
   * @param body @Object
   * @param negotiationId @string 
   * @returns 
   */
  makeCounterOffer(body: any , negotiationId: any) {
    return this.httpService.putMethod(this.negotiationUrl+`/${negotiationId}`,body);
  }

  /**
   * All Accepted Negotiation api 
   * function
   * @param negotiationId: @string
   * @param offerIndex  @Number
   * @returns 
   */
  acceptNegotiationOffer(negotiationId: any,offerIndex: any) {
    return this.httpService.putMethod(this.negotiationUrl+`/${negotiationId}/accept/${offerIndex}`,{});
  }

  /**
   * Update or Modification of negotiation
   * according to ui requirement
   * @param negotiationList @@ ARray
   * @param type @: string
   * @returns 
   */
  prepareNegotiationList(negotiationList: Array<any>, type:string ): Array<NegotiationList> {
    let finalList: Array<NegotiationList> = [];
    if (negotiationList.length > 0) {
      negotiationList.map((negotiationItem: any, index: number) => {
        let object:any = {
          negotiationId: negotiationItem.negotiationId,
          acceptedOffer: negotiationItem.acceptedOffer,
          isOfferAccepted: negotiationItem.acceptedOffer && Object.keys(negotiationItem.acceptedOffer).length > 0 ?  true : false,
          beatOwner: {
            _id:negotiationItem?.beatOwner?._id,
            handle: negotiationItem?.beatOwner?.handle,
            name: negotiationItem?.beatOwner?.name
          },
          startedBy: negotiationItem?.startedBy,
          negotiationStartDate: negotiationItem?.negotiationStartDate,
          beatDetails: {
            _id:negotiationItem?.beatDetails?._id,
            cover_picture:negotiationItem?.beatDetails?.cover_picture,
            title: negotiationItem?.beatDetails?.title,
            serial_number:negotiationItem?.beatSerialNumber,
            id: negotiationItem?.beatDetails?.id,
            price: negotiationItem?.beatDetails?.price
          },
          isActive: negotiationItem?.isActive,
          negotiationSuccessful: negotiationItem?.negotiationSuccessful,
          type: type,
          isSelected: false,
          unread: negotiationItem?.unread,
          updatedAt: negotiationItem?.updatedAt
        }
        object['offers'] = this.prepareOfferList(negotiationItem, type).offerList;
        object['currentRound'] = this.prepareOfferList(negotiationItem, type).currentRound;
        finalList.push(object);
      })
    }
    return finalList
  }

  /**
   * Prepare Offer List Data
   * @param negotiationItem : Object
   * @returns @: Object
   */
  prepareOfferList(negotiationItem:any, type: string = "") {
   let finalOfferList: Array<any> = [];
   let currentRound: Array<any> = [];
   let countRound = 0;
    negotiationItem.offers.map((offerItem: any, indexOffer: number) => {
      let ObjectMain: any = {}
      let headerList: Array<string> = []
      ObjectMain['isPosition'] = offerItem.offeredBy === this.currentUserData._id ? 'right' : 'left';
      ObjectMain["isDisabled"] = indexOffer < negotiationItem.offers.length - 1 || offerItem.offeredBy === this.currentUserData._id ? true : false  ||  negotiationItem.acceptedOffer && Object.keys(negotiationItem.acceptedOffer).length > 0 || !negotiationItem.isActive;
      ObjectMain['offeredBy'] = offerItem.offeredBy;
      ObjectMain['offerDate'] = offerItem.offerDate;
      let finalProfileString = this.getProfileName(ObjectMain['isPosition'],type, negotiationItem);
      if (finalProfileString) {
        ObjectMain["profileString"] = {
          "type": "string",
          "value": finalProfileString
        };
      } else {
        ObjectMain["profileString"] = {
          "type": "string",
          "value": this.profileStringWithNameLetterPipe.transform("Ipm User")
        };
      }
      if (negotiationItem.offers.length === 1 || indexOffer === 0) {
        headerList= ["Original Offer"];
        if (offerItem.offeredBy === this.currentUserData._id) {
          headerList.push("My Offer");
        } else {
          let headerLabel: string = this.currentUserData.role === "producer" ? "Buyer Offer": "Seller Offer" ;
          headerList.push(headerLabel);
        }
      } else {
        if (this.currentUserData.role === "producer") {
          headerList = type === 'selling' ? ["Buyer Offer"] : ["Seller Offer"];
        } else {
          headerList = ["Seller Offer"];
        }
        headerList.push("My Offer")
        if (offerItem.offeredBy !== this.currentUserData._id) {
          headerList.reverse();
        }
      }
      ObjectMain["header"] = headerList;
      if (indexOffer % 2  === 0) {
        currentRound.push({
          label:"Round "+countRound,
          currentIndex: indexOffer,
        });
        countRound++;
      }
      ObjectMain['roundType'] = countRound;
      let finalOfferDetails: Array<any> = [];
      this.labelArray.map(((labelItem: any) => {
          let object: any = {
            "label_Name": labelItem.name,
            "symbolType": labelItem.type,
            "isCounterEnable": false,
            "isAccepted": false,
            "isRejected": false,
            "isAllowedInput": true,
            "formModel": "",
            "currentOffer": {
              offeredBy: offerItem?.offeredBy,
              offerDate: offerItem?.offerDate,
              _id: offerItem?._id,
              value: "",
            },
            "isValid": true,
            "previousOffer": {}
          }
          if (negotiationItem.offers.length === 1 || indexOffer === 0 ) {
            object['previousOffer']['offeredBy'] = "";
            object['previousOffer']['offerDate'] = "";
            object['previousOffer']['_id'] = "";
            object['previousOffer']['value'] = "";
          } else {
            object['previousOffer']['offeredBy'] = negotiationItem.offers[indexOffer - 1].offeredBy;
            object['previousOffer']['offerDate'] = negotiationItem.offers[indexOffer - 1].offerDate;
            object['previousOffer']['_id'] = negotiationItem.offers[indexOffer - 1]._id;
          }
          let  previousIsAccepted: boolean = true;  
          if (finalOfferList[finalOfferList.length - 1 ]) {
            let previousOfferDetails: any = finalOfferList[finalOfferList.length - 1].OfferDetails;
            let  foundValue  = previousOfferDetails.find((previousOfferObj: any) => previousOfferObj.label_Name === labelItem.name);
            if (foundValue) {
              previousIsAccepted = foundValue.isAccepted;
            }
          }
          switch(labelItem.name) {
            case 'License Fee':
              object['currentOffer']['value'] = offerItem?.price;
              object.formModel = offerItem?.price;
              if (negotiationItem.offers.length > 1 && indexOffer > 0 ) {
                object['previousOffer']['value'] = negotiationItem.offers[indexOffer - 1].price;
                object = this.updateValueOnOfferDetails(object, negotiationItem, indexOffer, negotiationItem.isActive, previousIsAccepted);
              }  
            break;
            case 'Publishing Rights':
              object['currentOffer']['value'] = offerItem?.publishingPercentage;
              object.formModel = offerItem?.publishingPercentage;
              if (negotiationItem.offers.length > 1 && indexOffer > 0 ) {
                object['previousOffer']['value'] = negotiationItem.offers[indexOffer - 1].publishingPercentage;
                object = this.updateValueOnOfferDetails(object, negotiationItem, indexOffer, negotiationItem.isActive, previousIsAccepted);
              }
            break;
            default:
              object['currentOffer']['value'] = offerItem?.masterPercentage;
              object.formModel = offerItem?.masterPercentage;
              if (negotiationItem.offers.length > 1 && indexOffer > 0 ) {
                object['previousOffer']['value'] = negotiationItem.offers[indexOffer - 1].masterPercentage;
                object = this.updateValueOnOfferDetails(object, negotiationItem, indexOffer, negotiationItem.isActive, previousIsAccepted) ;
              }
            break;
            // default:
            //   object['currentOffer']['value'] = "Yes";
            //   object.formModel = "Yes";
            //   if (negotiationItem.offers.length > 1 && indexOffer > 0 ) {
            //     object['previousOffer']['value'] = "Yes";
            //     object = this.updateValueOnOfferDetails(object, negotiationItem, indexOffer, negotiationItem.isActive, previousIsAccepted);
            //   }
            // break;
          }
          finalOfferDetails.push(object);
      }));
      ObjectMain['OfferDetails'] = finalOfferDetails;
      finalOfferList.push(ObjectMain);
    });
    if (finalOfferList.length - 1  === 4) {
      finalOfferList = this.updateLastIndexInOfferDetails(negotiationItem, finalOfferList, type);
    }
    return {
      offerList: finalOfferList,
      currentRound: currentRound
    }
  }

  /**
   * In this Function 
   * @param negotiationItem 
   */
  updateLastIndexInOfferDetails(negotiationItem: any, finalOfferList: Array<any>, listType: string): Array<any> {
    let offerArrayList: Array<any> = JSON.parse(JSON.stringify(finalOfferList));
    if (offerArrayList.length > 0) {
      let lastOfferList: any  =  offerArrayList[offerArrayList.length - 1];
      let tempOfferObject: any = JSON.parse(JSON.stringify(lastOfferList));
      let isPosition =  lastOfferList.isPosition === 'left' ? "right" : "left";
      tempOfferObject.isPosition = isPosition;
      let offerDetails: any = lastOfferList.OfferDetails;
      if (offerDetails &&  offerDetails.length > 0) {
        let isAlreadyAdded: boolean =  true;
        let type: string = "";
        if (negotiationItem?.acceptedOffer && negotiationItem.isActive) {
          isAlreadyAdded = offerDetails.every((offerDetailsObj: any)  =>  offerDetailsObj.isAccepted === true);
          type = "accepted";
        } else if (!negotiationItem.isActive) {
          isAlreadyAdded = offerDetails.every((offerDetailsObj: any)  =>  offerDetailsObj.isRejected === true);
          if (!isAlreadyAdded) {
            let count = 0;
            offerDetails.filter((offerDetailsObj: any)  => {
              if (offerDetailsObj.isAccepted || offerDetailsObj.isRejected === true) {
                count++;
              }
            });
            if (count !== 4) {
              type = "rejected";
              isAlreadyAdded = false;
            } else {
              isAlreadyAdded = true;
            }
          }
        }
        if (!isAlreadyAdded) {
          let offerObject: any = this.updateOfferDetailsSummaryIndex(type, tempOfferObject, isPosition, negotiationItem, listType);
          if (offerObject) {
            offerObject['typeOfObject'] = "summary"
            offerArrayList.push(offerObject);
          }
        }
      }
    }
    return offerArrayList;
  }

  /**
   *  Generate the final summary of the object
   * of offer
   * @param type @string
   * @param tempOfferObject @Object 
   * @param isPosition @string  
   * @param negotiationItem @objet 
   * @param currentListType @string
   * @returns 
   */
  updateOfferDetailsSummaryIndex(type: string, tempOfferObject: any, isPosition: string, negotiationItem: any, currentListType: string ) {
    tempOfferObject.OfferDetails = tempOfferObject.OfferDetails.filter((item: any) =>  {
      if (type === "accepted")  {
        item.isAccepted = true;
        item.isRejected = false;
      } else {
        if (!item.isAccepted) {
          item.isRejected = true;
        }
      }
      item.previousOffer.value = item.currentOffer.value
      return item;
    });

    tempOfferObject.profileString.value = this.getProfileName(isPosition,currentListType, negotiationItem);
    let headerList = [];
    if (this.currentUserData.role === "producer") {
      headerList = currentListType === 'selling' ? ["Buyer Offer"] : ["Seller Offer"];
    } else {
      headerList = ["Seller Offer"];
    }
    headerList.push("My Offer")
    if (isPosition === 'left') {
      headerList.reverse();
    }
    tempOfferObject.header = headerList;
    return tempOfferObject;
  }

  getProfileName(isPosition: string, currentListType: string, negotiationItem: any){
    let finalProfileValue: string = ""
    if (this.currentUserData.role === "producer") {
      if ( isPosition === 'left' ) {
        if (currentListType === "selling") { 
          if (negotiationItem?.startedBy?.name) {
            finalProfileValue = this.profileStringWithNameLetterPipe.transform(negotiationItem?.startedBy?.name);
          }
        } else {
          if (negotiationItem?.beatOwner?.name) {
            finalProfileValue = this.profileStringWithNameLetterPipe.transform(negotiationItem?.beatOwner?.name);
          }
        }
      } else {
        if (this.currentUserData?.name) {
          finalProfileValue = this.profileStringWithNameLetterPipe.transform(this.currentUserData.name);
        }
      }
    } else {
      if ( isPosition === 'left' ) {
        if (negotiationItem?.beatOwner?.name) {
          finalProfileValue = this.profileStringWithNameLetterPipe.transform(negotiationItem?.beatOwner?.name);
        }
      } else {
        if (this.currentUserData?.name) {
          finalProfileValue = this.profileStringWithNameLetterPipe.transform(this.currentUserData.name);
        }
      }
    }
    return finalProfileValue;
  }

  /**
   * update accept and reject according to the 
   * conditions
   * @param offerObject 
   * @param offerList 
   * @param offerIndex 
   * @param isNegotiationActive 
   * @param previousOfferIsAccepted 
   * @returns 
   */
  updateValueOnOfferDetails(offerObject: any, mainOfferObj: any, offerIndex: number, isNegotiationActive: boolean, previousOfferIsAccepted: any) {
    let  object: any = JSON.parse(JSON.stringify(offerObject));
    let offerList: Array<any> = mainOfferObj.offers;
    let isNegotiationSuccessFull = mainOfferObj.negotiationSuccessful;
    if (object['previousOffer']['value'] === object['currentOffer']['value']) {
      if (!isNegotiationActive &&  offerIndex === offerList.length - 1 && !previousOfferIsAccepted) {
          object.isRejected = false;
          object.isAccepted = false;
      } else {
        object.isAllowedInput = false;
        object.isAccepted = true;
      }
    } else {
      if ((!isNegotiationActive && !isNegotiationSuccessFull) &&  !mainOfferObj.acceptedOffer) {
        if (offerIndex === offerList.length - 1) {
          object.isRejected = false;
          object.isAccepted = false;
        } else {
          object.isAccepted = false;
          object.isRejected = false;
        }
      }
    }
    return object;
  }

  /**
   * In this function prepare send for api   
   * @param offerDetailsArray @Array
   * @returns 
   */
  getBodyApiData(offerDetailsArray: Array<any>, type: string = "") {
    let sendObject: any = {};

      offerDetailsArray.map( item => {
      switch(item.label_Name) {
        case 'License Fee':
          sendObject.price =  type ? +item.currentOffer.value : +item.formModel;
        break;
        case 'Publishing Rights':
          sendObject.publishingPercentage =  type ? +item.currentOffer.value : +item.formModel;
        break;
        case 'Master Rights':
          sendObject.masterPercentage =  0;
        break;
      }
    });
    return sendObject;
  }

  /**
   * Add Query Params On url
   * @param negotiationId 
   */
  addQueryParamsNegotiation(negotiationId: any, type: string = "") {
    let url: any = this.router.url;
    let  path = "negotiations";
    this.router.navigate([path], { relativeTo: this.routerActivated ,queryParams: {"n": negotiationId, "t": type}});
  }
  
  /**
   * get All Notification
   * @returns 
   */
  getAllNegotiationNotification(type: string, isShowLoader: boolean = true, page: number = 1, limit: number = 20) {
     const url = `${this.notification}?page=${page}&limit=${limit}`;
      return this.httpService.getMethod(url, isShowLoader).pipe(map(notificationRes => {
       // Support both new paginated response { notifications: [...], unreadCount, ... }
       // and legacy raw array response for backward compatibility
       const notifications = this.normalizeNotificationList(notificationRes?.notifications || notificationRes);
       const unreadCount = notificationRes?.unreadCount ?? notifications.filter(item => item.unread).length;
       const total = notificationRes?.total ?? notifications.length;

       if (page > 1 || type === 'pagination') {
         this.notificationsCache = this.mergeNotificationLists(this.notificationsCache, notifications);
       } else {
         this.notificationsCache = notifications;
       }

       this.unreadCountCache = unreadCount;
       this.totalCountCache = total;

       this.emitNotificationChanges(type, this.notificationsCache, this.unreadCountCache, this.totalCountCache);
       return notificationRes;
      }),catchError((error: any) => {
        return throwError(error)
      }));
  }

  pushRealtimeNotification(notification: any): boolean {
    if (!notification || typeof notification !== 'object' || !notification._id) {
      return false;
    }

    const normalizedNotification = this.normalizeNotification(notification, true);
    if (!normalizedNotification) {
      return false;
    }

    const foundIndex = this.notificationsCache.findIndex(item => item._id === normalizedNotification._id);
    if (foundIndex > -1) {
      this.notificationsCache[foundIndex] = { ...this.notificationsCache[foundIndex], ...normalizedNotification };
      this.emitNotificationChanges('realtime-update', this.notificationsCache, this.unreadCountCache, this.totalCountCache);
      return false;
    } else {
      this.notificationsCache = [normalizedNotification, ...this.notificationsCache];
      if (normalizedNotification.unread) {
        this.unreadCountCache = this.unreadCountCache + 1;
      }
      this.totalCountCache = this.totalCountCache + 1;
    }

    this.emitNotificationChanges('realtime', this.notificationsCache, this.unreadCountCache, this.totalCountCache);
    return true;
  }

  resetNotificationState() {
    this.notificationsCache = [];
    this.unreadCountCache = 0;
    this.totalCountCache = 0;
    this.emitNotificationChanges('reset', [], 0, 0);
  }

  private mergeNotificationLists(existingList: NotificationResModel[], nextList: NotificationResModel[]) {
    let finalList: NotificationResModel[] = [...existingList];
    nextList.forEach(notification => {
      const foundIndex = finalList.findIndex(item => item._id === notification._id);
      if (foundIndex > -1) {
        finalList[foundIndex] = { ...finalList[foundIndex], ...notification };
      } else {
        finalList.push(notification);
      }
    });
    return finalList;
  }

  private normalizeNotificationList(notificationList: any): NotificationResModel[] {
    if (!Array.isArray(notificationList)) {
      return [];
    }
    const finalList: NotificationResModel[] = [];
    notificationList.forEach(notification => {
      const normalizedNotification = this.normalizeNotification(notification);
      if (normalizedNotification) {
        const existingIndex = finalList.findIndex(item => item._id === normalizedNotification._id);
        if (existingIndex > -1) {
          finalList[existingIndex] = { ...finalList[existingIndex], ...normalizedNotification };
        } else {
          finalList.push(normalizedNotification);
        }
      }
    });
    return finalList;
  }

  private normalizeNotification(notification: any, requireMongoId: boolean = false): NotificationResModel | null {
    if (!notification || typeof notification !== 'object') {
      return null;
    }

    const notificationId = requireMongoId ? notification?._id : (notification?._id || notification?.id);
    if (!notificationId) {
      return null;
    }

    return {
      _id: notificationId,
      message: notification?.message || '',
      payload: notification?.payload || {},
      type: notification?.type || '',
      category: notification?.category || '',
      unread: notification?.unread !== false,
      createdAt: notification?.createdAt || new Date().toISOString(),
      updatedAt: notification?.updatedAt || notification?.createdAt || new Date().toISOString(),
      userId: notification?.userId || '',
      __v: notification?.__v ?? 0
    };
  }

  private emitNotificationChanges(
    notificationType: string,
    notificationData: NotificationResModel[],
    unreadCount: number,
    total: number,
    notificationId?: string
  ) {
    const payload: NotificationChangeEvent = {
      notificationType,
      notificationData,
      unreadCount,
      total
    };
    if (notificationId) {
      payload.notificationId = notificationId;
    }
    this.notificationChanges.next([payload]);
  }

  setReadNegotiation(id: string,type: string = "", showLoader: boolean = true) {
    let urlName: string = this.negotiationUrl;
    if (type) {
      urlName = this.notification;
    }
    return this.httpService.putMethod(`${urlName}/${id}/setRead`, {}, showLoader);
  }
  setUnreadNegotiation(id: string,type: string = "", showLoader: boolean = true) {
    let urlName: string = this.negotiationUrl;
    if (type) {
      urlName = this.notification;
    }
    return this.httpService.putMethod(`${urlName}/${id}/setUnread`, {}, showLoader);
  }
  
  markAllRead(showLoader: boolean = true) {
    return this.httpService.putMethod(`${this.notification}/markAllRead`, {}, showLoader);
  }
}
